import type { EvidenceItem } from '@/mocks/topics';

const weightMeta: Record<EvidenceItem['weight'], { label: string; tone: string; icon: string }> = {
  strong: { label: '高可信', tone: 'bg-accent-100 text-accent-800 border-accent-200', icon: 'ri-shield-check-line' },
  medium: { label: '可参考', tone: 'bg-secondary-100 text-secondary-800 border-secondary-200', icon: 'ri-bookmark-3-line' },
  weak: { label: '弱信号', tone: 'bg-background-200 text-foreground-700 border-background-300', icon: 'ri-question-line' },
  counter: { label: '反证', tone: 'bg-primary-100 text-primary-800 border-primary-200', icon: 'ri-close-circle-line' },
};

interface EvidenceListProps {
  items: EvidenceItem[];
}

export default function EvidenceList({ items }: EvidenceListProps) {
  return (
    <ul className="space-y-4">
      {items.map((item, index) => {
        const meta = weightMeta[item.weight];
        return (
          <li key={item.source} className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div className="flex items-center gap-2">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-foreground-950 font-label text-[11px] font-bold text-background-50">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                  {item.source}
                </span>
              </div>
              <span
                className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-1 font-label text-xs ${meta.tone}`}
              >
                <i className={meta.icon}></i>
                {meta.label}
              </span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">{item.detail}</p>
          </li>
        );
      })}
    </ul>
  );
}